import React from "react";
export default function Registration() {
  return <h1>Registration</h1>;
}
